import { ComboboxSingleSelect } from '@eggplant/pattern-library'
import type { DateOptionType } from '../types'
import type {
  DateRangeOptions,
  Options
} from '@eggplant/types'

interface Props{
  isDisabled?: boolean
  onChange: (value: DateRangeOptions) => void
  value: DateRangeOptions
  optionVariances?: DateOptionType[]
  isClearable?: boolean
}

const defaultOptions: Options = [
  { label: 'Custom Range', value: 'custom-range' }
]

const hourOptions: Options = [
  { label: 'Last 8 hours', value: 'last-8-hours' },
  { label: 'Last 24 hours', value: 'last-24-hours' }
]

const dayOptions: Options = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 3 Days', value: 'last-3-days' },
  { label: 'Last 7 Days', value: 'last-7-days' }
]

const weekOptions: Options = [
  { label: 'Last 2 Weeks', value: 'last-2-weeks' },
  { label: 'Last 3 Weeks', value: 'last-3-weeks' }
]

const monthOptions: Options = [
  { label: 'Last Month', value: 'last-month' },
  { label: 'Last 3 Months', value: 'last-3-months' }
]

const optionVarianceMap = {
  hour: hourOptions,
  day: dayOptions,
  week: weekOptions,
  month: monthOptions
}

const SelectDateRange = ({
  isDisabled = false,
  onChange,
  value,
  optionVariances = ['day', 'week', 'month'],
  isClearable = true
}: Props) => {
  const getOptions = (dateType: DateOptionType) =>
    optionVariances.some(variance => variance === dateType)
      ? optionVarianceMap[dateType]
      : []

  const options = [
    ...defaultOptions,
    ...getOptions('hour'),
    ...getOptions('day'),
    ...getOptions('week'),
    ...getOptions('month')
  ]

  const handleDateRangeChange = (dateRange: string) => {
    const inputOrDefaultValue = dateRange as DateRangeOptions

    onChange(inputOrDefaultValue)
  }

  return (
    <ComboboxSingleSelect
      ariaLabel='Date Range Combobox'
      disableSorting
      isClearable={isClearable}
      isDisabled={isDisabled}
      isHighlighted={value !== 'last-7-days'}
      isRequired={false}
      onChange={handleDateRangeChange}
      options={options}
      prompt='Select Date Range'
      value={value}
    />
  )
}

export default SelectDateRange
